export const RHI_ROUTES = {
  HOME: '/retail/health-insurance',
  SELECT_MEMBER: '/retail/health-insurance/select-member',
  PLANS_BENEFITS: '/retail/health-insurance/plans-benefits',
  RECOMMENDATION: '/retail/health-insurance/recommendation',
  ADD_RIDERS: (planId: string) =>
    `/retail/health-insurance/add-riders/${planId}`,
  VERIFY_DETAILS: '/retail/health-insurance/verify-details',
  BANK_DETAILS: '/retail/health-insurance/bank-details',
  ADD_NOMINEE: '/retail/health-insurance/add-nominee',
  MEMBER_DETAILS: '/retail/health-insurance/member-details',
  MEMBER_DETAILS_RELATION: (relation: string) =>
    `/retail/health-insurance/member-details/${relation}`,
  CHECKOUT: '/retail/health-insurance/checkout',
  POST_PAYMENT: '/retail/health-insurance/post-payment',
  PAYMENT_FAILED: '/retail/health-insurance/payment-failed',
  POLICY_STATUS: (status: string) =>
    `/retail/health-insurance/policy-status/${status}`,
  THANK_YOU: '/retail/health-insurance/thank-you',
  ERROR: '/retail/health-insurance/error',
} as const;
